
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les 8 meilleures pratiques pour rédiger des annonces Google Ads",
    description:
      "Apprenez à rédiger des annonces Google Ads performantes avec nos conseils. Attirez l'attention, augmentez votre taux de clics et maximisez vos conversions.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
